<template>
    <ion-footer collapse="fade" id="footer">
        <ion-grid id="footer-content">
            <ion-row class="ion-justify-content-start ion-align-items-center ion-padding-bottom ion-padding-top">
                <ion-col size="12" size-md="6" size-lg="auto" v-for="link in topLinks" :key="link.name" :class="{ 'ion-text-center': !isMobile }" class="top-links">
                    <router-link :to="{ path: link.to, query: { utm_medium: 'web', utm_source: 'footer' } }" v-if="link.to" class="color-white no-underline large footer-nav-link" data-link="footer">
                        {{ link.name }}
                    </router-link>
                    <a v-else-if="link.href" :href="link.href" target="_blank" class="color-white no-underline large footer-nav-link">
                        {{ link.name }}
                    </a>
                </ion-col>
            </ion-row>

            <div class="footer-links">
                <ion-row>
                    <ion-col size="12" size-md="5" class="pl-0">
                        <ion-row>
                            <ion-col size="12" class="px-0 ion-text-uppercase">
                                <ion-label color="medium">
                                    <b> About </b>
                                </ion-label>
                            </ion-col>
                            <ion-col size="6" size-md="5" v-for="link in aboutLinks" :key="link.name" class="pl-0 pr-0">
                                <a v-if="link.to.includes('http')" :href="link.to" target="_blank" class="color-white no-underline large">{{ link.name }}</a>
                                <router-link v-else :to="{ path: link.to, query: { utm_medium: 'web', utm_source: 'footer' } }" class="color-white no-underline large" data-link="footer">
                                    {{ link.name }}
                                </router-link>
                            </ion-col>
                        </ion-row>
                    </ion-col>

                    <ion-col size="12" size-md="3" offset-md="1" class="px-0 sub-columns">
                        <ion-row class="full-height">
                            <ion-col size="12" class="px-0">
                                <ion-label color="medium" class="ion-text-uppercase">
                                    <b> Connect With Us</b>
                                </ion-label>
                            </ion-col>
                            <ion-col size="3" v-for="link in socialLinks" :key="link.name" class="pa-0">
                                <ion-button :href="link.href" target="_blank" fill="clear" class="social-btn px-0">
                                    <ion-icon slot="icon-only" :aria-label="'link to ' + link.name" :alt="link.name" :icon="link.logo" class="full-height full-width" />
                                </ion-button>
                            </ion-col>
                        </ion-row>
                    </ion-col>

                    <ion-col size-md="3" class="ion-align-items-center px-0 sub-columns" v-if="!isNative">
                        <ion-row class="full-height">
                            <ion-col size="12" class="px-0">
                                <ion-label color="medium" class="ion-text-uppercase">
                                    <b> Download our app </b>
                                </ion-label>
                            </ion-col>
                            <ion-col size="6" class="pa-0 full-height download-col">
                                <ion-button href="https://apps.apple.com/us/app/donatos/id599722601" target="_blank" fill="clear" class="pl-0 my-0 full-height download-btn">
                                    <ion-img alt="Apple Store Logo" slot="start" :src="require('@/assets/apple-store.svg')" class="full-height ma-0" />
                                </ion-button>
                            </ion-col>
                            <ion-col size="6" class="pa-0 full-height download-col">
                                <ion-button fill="clear" href="https://play.google.com/store/apps/details?id=com.donatos.phoenix" target="_blank" class="pr-0 my-0 full-height download-btn">
                                    <ion-img alt="GooglePlay Logo" :src="require('@/assets/google-play.svg')" class="full-height ma-0" />
                                </ion-button>
                            </ion-col>
                        </ion-row>
                    </ion-col>
                </ion-row>

                <ion-row class="ion-justify-content-between ion-align-items-center mt-button">
                    <ion-col size="12" class="ion-padding-start pa-0 small color-medium">
                        <router-link to="/copyright" data-link="footer" class="legal-link no-underline hover-underline"> © {{ new Date().getFullYear() }} Donatos Pizzeria, LLC.</router-link>
                        <br />
                        <router-link to="/termsandconditions" data-link="footer" class="legal-link no-underline hover-underline"> Terms &amp; Conditions </router-link>
                        <span class="small">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                        <router-link to="/privacy-policy" data-link="footer" class="legal-link no-underline hover-underline"> Privacy Policy </router-link>
                        <!-- <router-link to="/accessibility-statement" class="legal-link no-underline hover-underline"> Accessibility Statement </router-link> -->
                        <span class="small">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                        <a
                            href="https://forms.office.com/Pages/ResponsePage.aspx?id=YLMnacd2zUuOKRIbATdm80DINotpy6FMsJ9yNYe3oltUMEtGTFlYWDMzQUVWTzFVMVgxR0NLTDFHNi4u"
                            class="legal-link no-underline hover-underline"
                        >
                            Do not sell or share my data
                        </a>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <p class="legal-link">2,000 calories per day is used for general nutrition advice, but calorie needs may vary. Additional nutrition information is available upon request.</p>
                </ion-row>
                <div v-if="isNative" class="mobile-nav-space"></div>
            </div>
        </ion-grid>
        <div v-if="isNative" class="mobile-nav-space"></div>
    </ion-footer>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { IonFooter, IonGrid, IonRow, IonCol, IonLabel, IonButton, IonImg, IonIcon } from '@ionic/vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
export default defineComponent({
    components: { IonFooter, IonGrid, IonRow, IonCol, IonLabel, IonButton, IonImg, IonIcon },
    setup() {
        const store = useStore();
        const router = useRouter();
        const isMobile = computed(() => store.getters.isMobile);
        const isNative = computed(() => store.getters.isNative);
        const selectedStore = computed(() => store.getters.getSelectedLocation);

        const hideFooter = computed(() => router.currentRoute.value.meta?.hideFooter);
        const topLinks = [
            { name: 'Customer Service', to: '/customer-service' },
            { name: 'Gift Cards', to: '/giftcards' },
            { name: 'Catering', to: '/catering' },
            { name: 'Careers', to: '/careers' },
            {
                name: 'Own a Donatos',
                href: 'https://www.donatospizzafranchise.com/?SPPC=Offline&sppccampaignid=902738&utm_source=Scorpion%20Advertising&utm_medium=cpc&utm_campaign=Offline',
            },
        ];

        const socialLinks = [
            {
                name: 'Instagram',
                logo: require('@/assets/instagram.svg'),
                href: 'https://www.instagram.com/donatospizza/',
            },
            {
                name: 'Twitter',
                logo: require('@/assets/twitter.svg'),
                href: 'https://twitter.com/Donatos',
            },
            {
                name: 'Facebook',
                logo: require('@/assets/facebook.svg'),
                href: 'https://www.facebook.com/DonatosPizza',
            },
            {
                name: 'Yelp',
                logo: require('@/assets/yelp.svg'),
                href: selectedStore?.value?.yelp ?? 'https://www.yelp.com/biz/donatos-pizza-columbus-64',
            },
        ];
        const aboutLinks = [
            { name: 'Our Story', to: '/company' },
            { name: 'All Locations', to: '/all-locations' },
            { name: 'Giving Back', to: '/givingback' },
            { name: 'Sustainability', to: '/sustainability' },
            { name: 'News', to: 'https://www.donatospizzafranchise.com/in-the-news/' },
            { name: 'Nutrition', to: '/nutrition' },
        ];

        return { topLinks, aboutLinks, socialLinks, isMobile, hideFooter, isNative };
    },
});
</script>

<style scoped>
#footer {
    background-color: black;
    color: var(--ion-color-primary-contrast);
}

#footer-content {
    max-width: 1000px;
}

.download-btn {
    --padding-start: 0;
    --border-radius: 0;
}

.social-btn {
    height: 40px;
    width: 40px;
    --padding-start: 0;
    --padding-end: 0;
}

.legal-link {
    display: inline-block;
    font-size: 11px;
    font-weight: bold;
    color: var(--ion-color-medium) !important;
}

.download-col {
    height: 65px !important;
}

.footer-nav-link {
    padding-right: 2em;
}

@media all and (min-width: 1140px) {
    #footer-content {
        max-width: 1100px;
    }
}

@media screen and (min-width: 960px) {
    .top-links:first-child {
        padding-left: 0;
    }

    #footer-content {
        max-width: 90%;
    }
}

@media screen and (max-width: 960px) {
    .social-btn {
        height: 43px;
        width: 43px;
    }

    .footer-links {
        padding-left: 24px;
    }

    .footer-nav-link {
        padding-left: 1em;
    }

    .sub-columns {
        margin-top: 0;
        padding-left: 0;
    }

    .top-links {
        height: 50px;
    }
}
</style>
